import { Component } from '@angular/core';
import { OverlayService } from '@ui-core/services/overlay/overlay.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sit-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent {
  isVisibleSubject = new BehaviorSubject<boolean>(false);

  constructor(private overlayService: OverlayService) {
    this.overlayService.displayObservable.subscribe(
      this.handleStatus.bind(this)
    );
  }

  private handleStatus(isVisible: {
    status: boolean
  }): void {
    this.isVisibleSubject.next(isVisible.status);
  }
}
